import axios from 'axios';
import { config } from '../config';

/**
 * Brand/appearance settings from the public sites endpoint (Reservations.Api,
 * anonymous). The endpoint returns the full site payload; only the fields we
 * consume are typed here.
 */
export interface PublicSiteBrandSettings {
  serviceDisplayMode?: string | null;
}

const getSiteBySiteNodeId = async (siteNodeId: string): Promise<PublicSiteBrandSettings> => {
  const response = await axios.get(`${config.apiUrl}/api/sites/by-site-node-id/${siteNodeId}`);
  return response.data;
};

export const sitesApi = {
  getSiteBySiteNodeId,
};
